import Modalhandler from 'components/shared/modal/modal-handler'
import ClientAuthModal from 'components/shared/modals/client-auth'
import ModalSuccess from 'components/shared/modals/modal-success'
import ScheduleTourModal from 'components/shared/modals/schedule-tour'
import moment from 'moment'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { connect } from 'react-redux'

const ScheduleTour = ({
  title,
  spaces,
  place,
  className = 'flex items-center justify-center btn btn-primary w-full font-normal py-3 cursor-pointer hover:bg-secondary-darkorange',
  selectedSpace,
}) => {
  const [activeModal, setActiveModal] = useState('message')
  const [selected, setSelected] = useState({})

  const renderModal = (toggle) => {
    const handleToggle = () => {
      setActiveModal('')
      toggle()
    }

    const renderSubHeader = () => {
      const {
        space: {
          preFormatted: { title: spaceName },
        },
        schedule,
        time,
      } = selected
      const dateFormatted = moment(schedule, 'dddd, MMMM D').format('dddd, MMMM D')
      const timeFormatted = moment(time, 'hh:mma').format('hh:mm a')

      return (
        <h2 className="font-bold text-xl my-10 max-w-md">
          {spaceName}
          <span className="mx-1 font-normal">at</span>
          {title}
          <span className="mx-1 font-normal">on</span>
          {dateFormatted}
          <span className="mx-1 font-normal">at</span>
          {timeFormatted}
        </h2>
      )
    }

    switch (activeModal) {
      case 'sign-in':
        return <ClientAuthModal toggle={handleToggle} initial={'sign-in'} />
      case 'sign-up':
        return <ClientAuthModal toggle={handleToggle} initial={'sign-up'} />
      case 'success':
        return (
          <ModalSuccess header="All set! You just scheduled a tour for:" toggle={handleToggle}>
            {renderSubHeader()}
          </ModalSuccess>
        )
      case 'schedule':
      default:
        return (
          <ScheduleTourModal
            title={title}
            spaces={spaces}
            toggle={handleToggle}
            selectedSpace={selectedSpace}
            place={place}
            setActiveModal={setActiveModal}
            setSelected={(values) => setSelected(values)}
          />
        )
    }
  }

  return (
    <Modalhandler className={className} title="Schedule a Tour">
      {({ toggle }) => renderModal(toggle)}
    </Modalhandler>
  )
}

ScheduleTour.propTypes = {
  title: PropTypes.string,
  spaces: PropTypes.array,
  place: PropTypes.string,
  className: PropTypes.string,
  selectedSpace: PropTypes.object,
}

const mapStateToProps = ({ notification }) => ({
  notification,
})

const mapDispatchToprops = null

export default connect(mapStateToProps, mapDispatchToprops)(ScheduleTour)
